import { render, staticRenderFns } from "./index.vue?vue&type=template&id=865d0bae&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=865d0bae&lang=css&"
import style1 from "./index.vue?vue&type=style&index=1&id=865d0bae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "865d0bae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/BgUizHzZB/0/snt/info/info-customer/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('865d0bae')) {
      api.createRecord('865d0bae', component.options)
    } else {
      api.reload('865d0bae', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=865d0bae&scoped=true&", function () {
      api.rerender('865d0bae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Broadcast/Mobile/detail/index.vue"
export default component.exports